<template>
  <div style="width:100%;padding-bottom:5px;">
    <div style="z-index: 9;position: relative;top: 0;">
      <div class="width-main">
        <div class="flexHeader">
          <div class="logo" >
            <img style="width:110px;" @click="goHome()" src="../../assets/logo2.png"/>
            <div class="dash">|</div>
            <div class="event" >
              <img class="eventLogo" :src="'https://static.daoba.com/darkSportsLogo/'+ programId +'.png'" alt="">
              <div class="txt">
                <div class="main">{{program.englishName}}</div>
                <div class="sub">DAOBA MATCH</div>
              </div>
            </div>
          </div>
          <div>
            <div style="position: relative;top: 20px;">
              <LoginTag :isEvent="isEvent"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginTag from '@comm/components/LoginTag.vue'
export default {
  name: 'headers',
  components: {
    LoginTag
  },
  mounted () {
  },
  data () {
    return {
      programId: this.$route.query.programId,
      program: {},
      isEvent: true
    }
  },
  created () {
    this.getAllProgram()
  },
  methods: {
    goHome () {
      this.$router.push('/')
    },
    getAllProgram () {
      this.$api.match.getAllProgram().then(res => {
        if (res.status === 0) {
          let all = res.data
          all.forEach(item => {
            if (item.id == this.programId) {
              this.program = item
            }
          })
          this.program.englishName = this.program.englishName.toUpperCase()
          // console.log('res', this.program)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.flexHeader {
  display: flex;
  justify-content: space-between;
  z-index: 20;
  .logo {
    color: #fff;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .menu {
    display: flex;
    div {
      margin: 0 10px;
      padding: 18px 20px;
      color: #fff;
      cursor: pointer;
      font-size: 0.9rem;
      border-bottom: 2px solid transparent;
      text-align: center;
    }
    .menu-hover:hover{
      border-bottom: 2px solid #b01f23;
    }
    .current {
      border-bottom: 2px solid white;
    }
  }
  .ant-dropdown-link {
    color: #fff;
  }
}
.width-main {
  width: 1200px;
  margin: 0 auto;
}
.bg {
  background-color: rgb(247, 247, 247);
}
.mr18 {
  margin-right: 18px;
}
.dash{
  color: #000;
  margin-left: 20px;
}
.event{
 margin-left: 20px;
 display: flex;
 flex-direction: row;
 justify-content: flex-start;
 align-content: center;
}
.eventLogo{
  width: 70px;
  height: 70px;
}
.txt{
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  font-size: 16px;
  color: #000;
  font-weight: bold;
}
.sub{
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/MatchHeader.vue